var map = {
	"./added.svg": 115,
	"./arrow-back.svg": 118,
	"./arrow-down-small.svg": 98,
	"./arrow.svg": 101,
	"./audio.svg": 119,
	"./audio_speed.svg": 120,
	"./blink.svg": 129,
	"./blinkist.svg": 130,
	"./bookmark-filled.svg": 131,
	"./bookmark.svg": 121,
	"./checkbox-checked.svg": 77,
	"./checkbox-empty.svg": 78,
	"./checked.svg": 122,
	"./close.svg": 59,
	"./delete.svg": 132,
	"./download.svg": 133,
	"./error-filled.svg": 161,
	"./error.svg": 92,
	"./information.svg": 63,
	"./key_ideas.svg": 134,
	"./lock.svg": 79,
	"./open-external.svg": 135,
	"./radio-checked.svg": 123,
	"./radio-empty.svg": 124,
	"./read.svg": 125,
	"./search.svg": 93,
	"./square-blink.svg": 136,
	"./star-filled.svg": 137,
	"./thumbs-down.svg": 162,
	"./thumbs-up.svg": 163,
	"./time.svg": 102,
	"./user.svg": 164
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 160;